import { Typography } from 'amo-styling-library'
import { DataGrid } from '@mui/x-data-grid'
import { SimpleDashboardLayout } from '../components/layout/SimpleDashboardLayout'
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'

interface Message {
  id: string
  sender: string
  subject: string
  preview: string
  date: string
  read: boolean
}

const mockMessages: Message[] = [
  {
    id: '1',
    sender: 'System',
    subject: 'Status update transport',
    preview: 'De container is aangekomen op de bestemming...',
    date: '2024-01-12T10:30:00Z',
    read: false
  },
  {
    id: '2',
    sender: 'System',
    subject: 'Status update transport',
    preview: 'De container is aangekomen op de bestemming...',
    date: '2024-01-12T09:15:00Z',
    read: true
  },
  {
    id: '3',
    sender: 'System',
    subject: 'Status update transport',
    preview: 'De container is aangekomen op de bestemming...',
    date: '2024-01-11T18:00:00Z',
    read: true
  }
]

function InboxPage() {

  const columns: GridColDef[] = [
    {
      field: 'sender',
      headerName: 'Van',
      flex: 1,
      minWidth: 150
    },
    {
      field: 'subject',
      headerName: 'Onderwerp',
      flex: 1.5,
      minWidth: 200,
      renderCell: (params: GridRenderCellParams) => (
        <span style={{ fontWeight: params.row.read ? 400 : 600 }}>
          {params.value as string}
        </span>
      )
    },
    {
      field: 'preview',
      headerName: 'Voorvertoning',
      flex: 2,
      minWidth: 250
    },
    {
      field: 'date',
      headerName: 'Datum',
      flex: 1,
      minWidth: 150,
      renderCell: (params: GridRenderCellParams) => {
        const value = params.value as string
        return new Date(value).toLocaleString('nl-BE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      }
    },
    {
      field: 'read',
      headerName: 'Status',
      flex: 0.7,
      minWidth: 100,
      renderCell: (params: GridRenderCellParams) => (
        <span style={{
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          background: params.value ? '#E8F5E9' : '#FFF3E0',
          color: params.value ? '#2E7D32' : '#E65100'
        }}>
          {params.value ? 'Gelezen' : 'Nieuw'}
        </span>
      )
    }
  ]

  return (
    <SimpleDashboardLayout>
      <div className="bg-white rounded-lg p-6 h-full">
        <div className="flex justify-between items-center mb-6">
          <Typography variant="h2" className="text-gray-900">
            Inbox
          </Typography>
        </div>
        <div style={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={mockMessages}
            columns={columns}
            pageSizeOptions={[5, 10, 25]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
            }}
          />
        </div>
      </div>
    </SimpleDashboardLayout>
  )
}

export default InboxPage
